const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC85A6"
    },
    d: "M256,0c-57.989,0-105.165,47.178-105.165,105.165c0,57.989,47.176,105.165,105.165,105.165 s105.165-47.176,105.165-105.165C361.165,47.178,313.989,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E5F6"
    },
    d: "M256,260.609c-106.273,0-192.733,86.462-192.733,192.733c0,13.885,11.256,25.139,25.139,25.139 h335.188c13.883,0,25.139-11.254,25.139-25.139C448.733,347.071,362.273,260.609,256,260.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A4C6EC"
    },
    d: "M256,260.609v217.872h167.594c13.883,0,25.139-11.254,25.139-25.139 C448.733,347.071,362.273,260.609,256,260.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3366"
    },
    d: "M256,260.609c-13.883,0-25.139,11.257-25.139,25.139v201.113C230.861,500.746,242.117,512,256,512 s25.139-11.254,25.139-25.139V285.748C281.139,271.866,269.883,260.609,256,260.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE5C82"
    },
    d: "M256,0v210.331c57.989,0,105.165-47.176,105.165-105.165C361.165,47.178,313.989,0,256,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0f4dbdbda5b5ea4de1e41c7b4d3521ec.svg";
export { ForwardRef as ReactComponent };